import PropTypes from 'prop-types';
import { GECKO_CONSTS } from '../constants';

export const GeckoBtnModel = {
  name: PropTypes.string,
  icon: PropTypes.string,
  class: PropTypes.string,
  handler: PropTypes.func,
  disabledWhen: PropTypes.func,
  hideWhen: PropTypes.func,
  size: PropTypes.oneOf([GECKO_CONSTS.BTN_SIZE_LG, GECKO_CONSTS.BTN_SIZE_SM]),
  type: PropTypes.oneOf([
    GECKO_CONSTS.BTN_TYPE_DANGER,
    GECKO_CONSTS.BTN_TYPE_DEFAULT,
    GECKO_CONSTS.BTN_TYPE_PRIMARY,
    GECKO_CONSTS.BTN_TYPE_INFO,
    GECKO_CONSTS.BTN_TYPE_SUCCESS,
    GECKO_CONSTS.BTN_TYPE_WARNING,
    GECKO_CONSTS.BTN_TYPE_NAKED,
  ]),
  preset: PropTypes.oneOf([
    GECKO_CONSTS.BTN_PRESET_ACTIONS,
    GECKO_CONSTS.BTN_PRESET_ACTIONS_COMPACT,
    GECKO_CONSTS.BTN_PRESET_ADD,
    GECKO_CONSTS.BTN_PRESET_CLONE,
    GECKO_CONSTS.BTN_PRESET_CLOSE,
    GECKO_CONSTS.BTN_PRESET_LOGIN,
    GECKO_CONSTS.BTN_PRESET_REMOVE,
    GECKO_CONSTS.BTN_PRESET_SAVE,
    GECKO_CONSTS.BTN_PRESET_SEND,
  ]),
};

export const GeckoBtnsModel = PropTypes.arrayOf(PropTypes.shape(GeckoBtnModel));
